import React from "react";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { NotificationsFlyout } from "./NotificationsFlyout";
import { notifications } from "../../api/client";
import { useQuery } from "../../hooks/useApi";

interface AppShellProps {
  children: React.ReactNode;
  breadcrumbs?: string[];
  activeMenuItem?: string;
  notificationCount?: number;
  onNavigate?: (item: string) => void;
}

export function AppShell({
  children,
  breadcrumbs = [],
  activeMenuItem,
  notificationCount,
  onNavigate,
}: AppShellProps) {
  const [showNotifications, setShowNotifications] = React.useState(false);

  const { data: unreadData } = useQuery(() => notifications.unreadCount(), [], {
    pollInterval: 10 * 60 * 1000,
  });
  const liveCount = unreadData?.unread_count ?? 0;
  const badgeCount = notificationCount ?? liveCount;

  return (
    <div className="flex h-screen bg-duvi-bg">
      <Sidebar activeItem={activeMenuItem} onNavigate={onNavigate} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <TopBar
          breadcrumbs={breadcrumbs}
          notificationCount={badgeCount}
          onNotificationsClick={() => setShowNotifications(true)}
        />
        <main className="flex-1 overflow-y-auto">
          <div
            className="mx-auto"
            style={{
              padding: "var(--content-padding)",
              maxWidth: "var(--content-max-width)",
            }}
          >
            {children}
          </div>
        </main>
      </div>
      <NotificationsFlyout
        isOpen={showNotifications}
        onClose={() => setShowNotifications(false)}
      />
    </div>
  );
}
